/* Lunette — cart page: our rows live inside the cart, and stay current.
   The theme lays the cart out as a grid (title, line items, summary, "more blocks"). Our rows are
   separate sections, so by default they render below the whole grid — under the summary on a
   phone, below the fold on desktop. This moves them into the theme's own "more blocks" slot
   (left column, under the line items) and, whenever the theme re-renders the cart after a
   quantity change, fetches fresh HTML for them through Shopify's section rendering so the
   second-cup offer, the add-ons and the shipping line always match the cart.
   Installed from layout/theme.liquid; does nothing off the cart page. */
(function () {
  if (window.__lunCartSyncBound) return;
  window.__lunCartSyncBound = true;
  var KEYS = ['lun_cart_shipping', 'lun_cart_tiers', 'lun_cart_upsell', 'lun_cart_trust', 'lun_cart_sticky'];
  var kept = [];      // our section elements, held even while the theme's re-render detaches them
  var refreshing = null;

  function slot() { return document.querySelector('.cart-page__more-blocks'); }
  function place() {
    var s = slot(); if (!s) return false;
    kept.forEach(function (el) { if (el.parentNode !== s) s.appendChild(el); });
    return true;
  }
  function refresh() {
    if (!kept.length) return;
    var ids = kept.map(function (el) { return el.id.replace(/^shopify-section-/, ''); });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // plain request: an Accept: application/json header makes Shopify answer with cart.js instead
    fetch(root + 'cart?sections=' + ids.join(','))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        kept.forEach(function (el, i) {
          var html = data[ids[i]]; if (typeof html !== 'string') return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section') || doc.body;
          el.innerHTML = fresh.innerHTML;
          // inline <script> tags do not run through innerHTML: re-create them
          el.querySelectorAll('script').forEach(function (old) {
            var n = document.createElement('script'); n.textContent = old.textContent; old.replaceWith(n);
          });
        });
        place();
      })
      .catch(function () {});
  }
  function scheduleRefresh() {
    clearTimeout(refreshing);
    refreshing = setTimeout(refresh, 150);
  }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function init() {
    if (!onCartPage()) return;
    kept = KEYS.map(function (k) { return document.querySelector('.shopify-section[id$="__' + k + '"]'); }).filter(Boolean);
    if (!kept.length || !place()) return;
    var cartEl = document.querySelector('cart-items-component') || document.body;
    // The theme swaps the cart's HTML after a quantity change; our nodes fall out. Put them back, then fetch fresh copies.
    new MutationObserver(function () {
      var s = slot();
      if (s && kept.some(function (el) { return el.parentNode !== s; })) { place(); scheduleRefresh(); }
    }).observe(cartEl, { childList: true, subtree: true });
    document.addEventListener('cart:update', function (e) {
      var d = e && e.detail && e.detail.data;
      if (d && d.source === 'product-form-component') return; // that one navigates here anyway
      place(); scheduleRefresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
